<template>
  <router-view />
</template>

<script setup lang="ts">
import { useBase } from "@/composables/useBase";
import { useRequiredAuth } from "@/composables/useRequiredAuth";
import { useExceptionStore } from "@/stores/exceptionStore";
import { useDevice } from "src/composables/useDevice";
import { useAuthenStore } from "@/stores/authenStore";
import { onBeforeUnmount, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useLang } from "./composables/useLang";
import { useTheme } from "./composables/useTheme";

const { appNavigateTo, isDevMode } = useBase();
const exceptionStore = useExceptionStore();
const router = useRouter();
const authenStore = useAuthenStore();
const { initialQuasarDark } = useTheme();
const { initialLocale } = useLang();
const { initialDevice } = useDevice();
// AppSetup();
initialQuasarDark();
initialLocale();
useRequiredAuth();
onMounted(() => {
  initialDevice();

  if (
    exceptionStore.error &&
    exceptionStore.error.statusCode &&
    exceptionStore.error.message
  ) {
    appNavigateTo("/error", true);
  }
  if (authenStore.auth) {
    if (isDevMode()) {
      console.log("App.vue > authenStore >", authenStore.auth);
    }
    // authenStore.startRefreshTokenTimer();
  }
  window.onpopstate = () => {
    if (
      router.options.history.state.forward == "/auth/login" &&
      !authenStore.auth
    ) {
      window.history.forward();
    }
    // if (
    //   authenStore.auth !== undefined &&
    //   this.$route.path == '/login'
    // ) {
    //   this.$router.push('/');
    // }
    // if (authenStore.auth === undefined) {
    //   appNavigateTo('/auth/login', true);
    // }
  };
});

// watch(authenStore, (state) => {
//   if (state && state.sessionExpired) {
//     appNavigateTo('/auth/login', true);
//   }
// });
onBeforeUnmount(() => {});
</script>
